import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import { reset, setAllGroups, setTotal, setLoading } from './actions';

const totalReducer = handleActions(
  {
    [setTotal.toString()]: (_, { payload: total }) => total,
    [reset.toString()]: () => 0
  },
  0
);

const groupsReducer = handleActions(
  {
    [setAllGroups.toString()]: (_, { payload: groups }) => groups,
    [reset.toString()]: () => []
  },
  []
);

const loadingReducer = handleActions(
  {
    [setLoading.toString()]: (_, { payload: loading }) => loading,
    [reset.toString()]: () => false
  },
  false
);

export default combineReducers({
  total: totalReducer,
  groups: groupsReducer,
  loading: loadingReducer
});
